// extracted by mini-css-extract-plugin
export default {"main":"Checkbox_main__Mai4w","text":"Checkbox_text__g4Bch"};